import {useState} from "../../__snowpack__/pkg/react.js";
import {createModel} from "../../__snowpack__/pkg/hox.js";
import {axios} from "../lib/axios.js";
import {isEmpty, isNil} from "../../__snowpack__/pkg/lodash.js";
const STEP_TYPE = {
  0: "PROVINCE",
  1: "CITY",
  2: "DISTRICT",
  3: "ZIPCODE"
};
const PH_TYPE = {
  0: "PROVINCE",
  1: "CITY",
  2: "DISTRICT",
  3: "TOWN",
  4: "ZIPCODE"
};
export const useAreas = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [areasList, setAreasList] = useState([]);
  const [zipCodeList, setZipCodeList] = useState([]);
  const fetchData = async (params, selectedValue, step) => {
    try {
      setIsLoading(true);
      if (params && params.type.toLowerCase() === "country") {
        let multiCountrys = localStorage.multiCountrys ? JSON.parse(localStorage.multiCountrys) : [];
        if (isEmpty(multiCountrys)) {
          let {data} = await axios.post(`saas/product/v1/area`, {
            type: "COUNTRY",
            id: ""
          });
          data = data.map((item) => {
            item.children = null;
            item.step = 0;
            return item;
          });
          multiCountrys = data;
          localStorage.multiCountrys = JSON.stringify(data);
        }
        setAreasList(multiCountrys);
        return multiCountrys;
      } else {
        let multiArea = localStorage.multiArea ? JSON.parse(localStorage.multiArea) : {};
        let key = selectedValue.join("-");
        if (isEmpty(multiArea) || isNil(multiArea[key])) {
          let {data} = await axios.post(`saas/product/v1/area`, {
            type: selectedValue[0] === "PH" ? PH_TYPE[selectedValue.length - 1] : STEP_TYPE[selectedValue.length - 1],
            id: params.id,
            country: selectedValue[0]
          });
          data = data.map((item) => {
            item.children = null;
            item.step = selectedValue.length;
            return item;
          });
          if (!isEmpty(data)) {
            localStorage.multiArea = JSON.stringify(Object.assign(multiArea, {
              [key]: data
            }));
            multiArea[key] = data;
          }
        }
        setIsLoading(false);
        setAreasList(isNil(multiArea[key]) ? [] : multiArea[key]);
        return isNil(multiArea[key]) ? [] : multiArea[key];
      }
    } catch (error) {
      setAreasList([]);
      setIsLoading(false);
      return {areasList: []};
    } finally {
      setIsLoading(false);
    }
  };
  const fetchAreaList = async (params, selectedValue) => {
    try {
      setIsLoading(true);
      let {data = []} = await axios.post(`saas/common/area/list`, {
        ...params,
        countryCode: selectedValue?.[0]
      });
      setIsLoading(false);
      return data;
    } catch (error) {
      setIsLoading(false);
      return [];
    } finally {
      setIsLoading(false);
    }
  };
  const fetchZipCodeList = async (type, id, country) => {
    try {
      const {data} = await axios.post(`saas/product/v1/area`, {
        type,
        id,
        country
      });
      setZipCodeList(data);
      return data;
    } catch (e) {
      setZipCodeList([]);
      return [];
    }
  };
  return {
    isLoading,
    fetchData,
    areasList,
    fetchZipCodeList,
    zipCodeList,
    fetchAreaList
  };
};
export const useAreasModel = createModel(useAreas);
